import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { DemandsComponent } from './core/layout/pages/demands/demands.component';
import { NewDemandComponent } from './core/layout/pages/new-demand/new-demand.component';
import { LayoutComponent } from './core/layout/layout.component';
import { authRoutes } from './core/auth/auth.routes';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  ...authRoutes,
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { refreshOnNavigation: true },
        title: 'Retire Right',
      },
      {
        path: 'demands',
        component: DemandsComponent,
        canActivate: [authGuard],
        data: { refreshOnNavigation: true },
        title: 'My demands | Retire Right',
      },
      {
        path: 'assignments',
        component: DemandsComponent,
        canActivate: [authGuard],
        data: { refreshOnNavigation: true, pageTitle: 'My Assignments' },
        title: 'My Assignments | Retire Right',
      },
      {
        path: 'new',
        component: NewDemandComponent,
        canActivate: [authGuard],
        title: 'New Demand | Retire Right',
      },
    ],
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];
